import React from 'react';
import { useTranslation } from '../useTranslation';
var HARDCODED_TITLES = ['hint', 'solution', 'incorrect'];

var Title = function Title(_ref) {
  var title = _ref.title;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("h6", {
    className: "dc-sct-feedback__title"
  }, HARDCODED_TITLES.includes(title.toLowerCase()) ? t("FeedbacksTitle.".concat(title.toLowerCase())) : title);
};

export default Title;